import { LoyaltyFAQEntry } from '../LoyaltyFAQ';
import { LoyaltyHomeBody } from './LoyaltyHomeBody';
import { LoyaltyHomeChallenges } from './LoyaltyHomeChallenges';
import { LoyaltyHomeChallengesEmptyState } from './LoyaltyHomeChallengesEmptyState';
import { LoyaltyHomeChallengesRewardsContainer } from './LoyaltyHomeChallengesRewardsContainer';
import { LoyaltyHomeContainer } from './LoyaltyHomeContainer';
import { LoyaltyHomeErrorState } from './LoyaltyHomeErrorState';
import { LoyaltyHomeFAQ } from './LoyaltyHomeFAQ';
import { LoyaltyHomeFooter } from './LoyaltyHomeFooter';
import { LoyaltyHomeHeader } from './LoyaltyHomeHeader';
import { LoyaltyHomeHowItWorks } from './LoyaltyHomeHowItWorks';
import { LoyaltyHomeLegalDisclaimer } from './LoyaltyHomeLegalDisclaimer';
import { LoyaltyHomeProgressBenefit } from './LoyaltyHomeProgressBenefit';
import { LoyaltyHomeReturnHero } from './LoyaltyHomeReturnHero';
import { LoyaltyHomeRewards } from './LoyaltyHomeRewards';
import { LoyaltyHomeRewardsEmptyState } from './LoyaltyHomeRewardsEmptyState';
import { LoyaltyHomeRewardsGrid } from './LoyaltyHomeRewardsGrid';
import { LoyaltyHomeScanButton } from './LoyaltyHomeScanButton';
import { LoyaltyHomeUnlockableRewards } from './LoyaltyHomeUnlockableRewards';

export const LoyaltyHome = {
  Container: LoyaltyHomeContainer,
  ChallengeRewardsContainer: LoyaltyHomeChallengesRewardsContainer,
  Header: LoyaltyHomeHeader,
  Body: LoyaltyHomeBody,
  ProgressBenefit: LoyaltyHomeProgressBenefit,
  ReturnHero: LoyaltyHomeReturnHero,
  Footer: LoyaltyHomeFooter,
  Challenges: LoyaltyHomeChallenges,
  ChallengesEmptyState: LoyaltyHomeChallengesEmptyState,
  Rewards: LoyaltyHomeRewards,
  RewardsEmptyState: LoyaltyHomeRewardsEmptyState,
  RewardsGrid: LoyaltyHomeRewardsGrid,
  UnlockableRewards: LoyaltyHomeUnlockableRewards,
  HowItWorks: LoyaltyHomeHowItWorks,
  FAQ: LoyaltyHomeFAQ,
  FAQEntry: LoyaltyFAQEntry,
  ScanButton: LoyaltyHomeScanButton,
  ErrorState: LoyaltyHomeErrorState,
  LegalDisclaimer: LoyaltyHomeLegalDisclaimer,
};
